import React, { useState } from "react";
import { Box, Grid, TextField, Typography } from "@material-ui/core";
import {
  ButtonsWrapper,
  CancelButton,
  SaveButton
} from "../../../elements/Button";
import I18nText from "../../../elements/I18nText";

const ExportEmailForm = ({ onClose, isSubmitting, onSubmit, error }) => {
  const [email, setEmail] = useState("");

  const handleSubmit = () => {
    onSubmit(email);
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Box marginBottom={2}>
            <Typography variant="body2">
              <I18nText>devices.export.emailRequired.message</I18nText>
            </Typography>
          </Box>
          <Box marginBottom={4}>
            <TextField
              name="email"
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              label={<I18nText>users.common.email</I18nText>}
              variant="outlined"
              fullWidth={true}
              error={Boolean(error)}
              helperText={error}
            />
          </Box>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <ButtonsWrapper
            leftButton={
              <CancelButton onClick={() => onClose()} disabled={isSubmitting} />
            }
            rightButton={
              <SaveButton onClick={handleSubmit} disabled={isSubmitting} />
            }
          />
        </Grid>
      </Grid>
    </>
  );
};

export default ExportEmailForm;
